import PacManLoader from "@/pages/worth/PacManLoader";
import ChompToggle from "@/pages/flip/ChompToggle";

export const rareLabel = (r) => [r?.out_of_print && "Out of print", ...(r?.special || [])].filter(Boolean).join(" · ");

// Out-of-print or special release: Pac-Man munches the $ signs. `chip` for list rows, banner otherwise.
export default function RareAlert({ rarity, chip = false, testid = "rare-alert" }) {
  const label = rareLabel(rarity);
  if (!label) return null;
  if (chip) {
    return (
      <span className="inline-flex items-center gap-1 rounded-full bg-slate-900 px-1.5 py-0.5 text-[10px] font-bold text-amber-300" data-testid={testid}>
        <PacManLoader size={9} testid={`${testid}-pacman`} /> {label}
      </span>
    );
  }
  return (
    <div className="flex items-center gap-3 rounded-lg bg-slate-900 p-3 text-white shadow-md" role="alert" data-testid={testid}>
      <PacManLoader size={18} testid={`${testid}-pacman`} />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-bold text-amber-300" data-testid={`${testid}-label`}>{label}</p>
        <p className="text-[11px] text-slate-300">{rarity.out_of_print ? "Hard to find, so price it with confidence and check sold prices, not just asking prices." : "Special releases often sell above regular copies. Mention it in the title."}</p>
      </div>
      <ChompToggle kind="rare" testid={`${testid}-sound-toggle`} />
    </div>
  );
}
